


















































import Vue from "vue";
import UserAccountNo from "../models/UserAccountNo";
import store, { UserAccountNoStore } from "../services/UserAccountNoStore";
import uStore, { UserStore } from "../../user/services/UserStore";
import { t } from "@/plugins/i18n";

interface Data {
  store: UserAccountNoStore;
  uStore: UserStore;
  valid: boolean;
}

const CREATE_TITLE = t("UserAccountNo_FokonyviSzamlaLetrehozasa");
const MODIFY_TITLE = t("UserAccountNo_FokonyviSzamlaAdatokModositasa");

export default Vue.extend<Data, {}, {}, {}>({
  data() {
    return {
      store,
      uStore,
      valid: true,
    };
  },

  async beforeMount() {
    await this.store.loadUserAccountNo(Number(this.$route.params.accountId));
    await this.uStore.loadUsers();
  },

  computed: {
    title() {
      return this.store.userAccountNo?.id > 0 ? MODIFY_TITLE : CREATE_TITLE;
    },
  },

  methods: {
    cancel() {
      this.$router.push("/user-acc-no");
    },

    async save() {
      await this.store.save();
      this.$router.push("/user-acc-no");
    },
  },
});
